export default __webpack_public_path__ + "static/media/404.54e6b75c.svg";